import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Labels from "../labels/Labels";

export default function RefreshingIndicator(props) {
  return (
    <div style={{ marginBlock: "auto" }}>
      <CircularProgress
        style={{ color: "darkgray", marginRight: "10px" }}
        size="1rem"
        color="inherit"
      />
      <span style={{ color: "darkgray" }}>
        {Labels.getLabel("refreshingIndicator.refreshing", "Refreshing...")}
      </span>
    </div>
  );
}
